import React, {useContext} from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { CopyBlock, dracula } from "react-code-blocks";
import { CanvasContext } from "../contexts/CanvasContext";
import anime from 'animejs';

const PasteAnimationPanel = ({ animationScript, setAnimationScript, runPastedAnimation, onClose }) => {

    const { API_URL } = useContext(CanvasContext);
    const handlePastedAnimation = async () => {

        const response = await fetch(`${API_URL}/run_pasted_animation_code`, {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            },
            body: JSON.stringify({ animation_code: animationScript }),
        });
        if (response.ok) {
            const data = await response.json();
            console.log(data.animation_code);
            runPastedAnimation(data.animation_code);

          }
    };
      
  return (
    <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, fontSize: '2em', height: '50%', width:'40%', padding: 2, backgroundColor: 'black', color: 'white', overflowY: 'scroll' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h5" gutterBottom>
          Animation Script
        </Typography>
        <Button variant="contained" color="secondary" onClick={onClose}>
          Close
        </Button>
        <Button variant="contained" color="secondary" onClick={handlePastedAnimation}>
          Run Pasted Animation
        </Button>
      </Box>
    <textarea
      value={animationScript}
      onChange={(e) => setAnimationScript(e.target.value)} // Add a state update handler
      style={{
        width: '100%',
        height: '200px',
        backgroundColor: '#282a36', // Dracula theme background
        color: '#f8f8f2', // Dracula theme text color
        padding: '10px',
        borderRadius: '5px',
        border: 'none',
        resize: 'none',
        fontFamily: 'monospace', // For code-like appearance
        fontSize: '14px',
      }}
    />   
     </Paper>
  );
};

export default PasteAnimationPanel;
